// extracted by mini-css-extract-plugin
module.exports = {"item":"item--U-93E","textWrap":"textWrap--21wJ-","describe":"describe--3pqM6","aside":"aside--20nI6","plan":"plan--1zoW9","imageWrap":"imageWrap--1iUS5","tabs":"tabs--zSe59"};